import styled from 'styled-components';
import { brandRed } from '../constants/colours';
import { PropTypes } from 'prop-types';
import { up } from 'styled-breakpoints';

const Link = styled.a`
    color: ${brandRed};
    text-decoration: none;
    font-family: Gordita;
    font-weight: 500;
    text-align: center;
    display: block;
    font-size: 0.85em;

    ${up('md')} {
        font-size: 0.9em;
    }

    ${up('lg')} {
        font-size: 0.95em;
    }

    ${up('xxl')} {
        font-size: 1em;
    }
    
`;

function Hyperlink(props) {
    return (
        <Link href={props.href}>{props.text}</Link>
    )
}

Hyperlink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Hyperlink;